import React from 'react';

interface iconProps {
    disabled?: boolean;
}

export const WarningIcon: React.FC<iconProps> = ({ disabled }: iconProps) => {
    return <span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" fill="#FFB000" />
            <rect x="11" y="7" width="2" height="6" fill="#444845" />
            <rect x="11" y="15" width="2" height="2" fill="#444845" />
        </svg>
    </span>
}
